import { render, staticRenderFns } from "./b-footer.vue?vue&type=template&id=c13b741c"
import script from "./b-footer.vue?vue&type=script&lang=ts"
export * from "./b-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c13b741c')) {
      api.createRecord('c13b741c', component.options)
    } else {
      api.reload('c13b741c', component.options)
    }
    module.hot.accept("./b-footer.vue?vue&type=template&id=c13b741c", function () {
      api.rerender('c13b741c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/biz/b-footer.vue"
export default component.exports